const SCREEN_WIDTH = 1280;
const SCREEN_HEIGHT = 720;
const GOD_MODE = false; // Must be false on production.
const UNLOCK_LEVELS = false; // Must be false on production.
const MAX_INFLATION = 1000;

const ALLY_TEAM = 1;
const ENEMY_TEAM = 2;

const PLAYER_ID = 'player';
const LEVEL_BOSS_ID = 'boss';

// Character constants.
const BASE_EXP = 256;
const COIN_TEXT = 'U$D';
const BASE_HP = 500;
const HP_PER_LEVEL = 100;
const DAMAGE_PER_LEVEL = 5;

const STOIC_EXP_PERCENTAGE = 0.5;

export {
  SCREEN_WIDTH,
  SCREEN_HEIGHT,
  GOD_MODE,
  MAX_INFLATION,
  ALLY_TEAM,
  ENEMY_TEAM,
  PLAYER_ID,
  UNLOCK_LEVELS,
  LEVEL_BOSS_ID,
  BASE_EXP,
  COIN_TEXT,
  BASE_HP,
  HP_PER_LEVEL,
  DAMAGE_PER_LEVEL,
  STOIC_EXP_PERCENTAGE,
};
